import React from 'react';

import { UserImportFieldOptionAction, UserImportFieldOptionsModel } from  '@/models/ApiResponseModels/UserImportFieldOptionsModel';

export function getAction(value: UserImportFieldOptionAction) {
    switch(value){
        case 0:
            return 'Add If Empty';
        case 1: 
           return 'Overwrite';
        case 2: 
            return 'Ignore';
        default:
            return '';
    }
}

export interface IUserFieldOptions {
    formFields: UserImportFieldOptionsModel[],
    options: {val: number, name: string}[],
    optionFilter?: (option: {val: number, name: string}, propertyName?: string) => boolean,
    updateField: (name: string, value: number) => void
}

const UploadFieldOptions = ({formFields, options, optionFilter=() => true, updateField}:IUserFieldOptions) => {
    return (
        <table className="user-upload-field-table">
            <thead>
                <tr>
                    <th>Field</th>
                    <th>Existing User Action</th>
                    <th>New User Action</th>
                </tr>
            </thead>

            <tbody>
                {formFields.map((x:UserImportFieldOptionsModel, idx: number) => (
                    <tr key={`settings-row-${idx + 1}`}>
                        <td>{x.propertyName}</td>
                        
                        <td>{getAction(x.action)}</td>
                        <td>
                            <select 
                                aria-label={`${x.propertyName} existing user action`}
                                onChange={(e) => updateField(x.propertyName, parseInt(e.target.value))}
                            >
                                {options.filter((option) => optionFilter(option, x.propertyName)).map((option:any, idx: number) => (
                                    <option
                                        key={`${x.propertyName}-option-${idx}`}
                                        selected={option.val == x.action}
                                        value={option.val}
                                    >
                                        {option.name} 
                                    </option>
                                ))}
                            </select>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default UploadFieldOptions